import { AxiosInstance, AxiosResponse } from 'axios';
import {
  BulkCustomerUploadResponse,
  CreateCustomerRequest,
  Customer,
  PaginatedResponse,
  SearchParams,
  UpdateCustomerRequest,
} from '../../types';

/** Customer API calls and customer CSV import contract. */
export class CustomerApi {
  constructor(private readonly http: AxiosInstance) {}

  async getCustomers(): Promise<Customer[]> {
    const response: AxiosResponse<Customer[]> = await this.http.get('/customers');
    return response.data;
  }

  async getCustomersPaginated(params: SearchParams): Promise<PaginatedResponse<Customer>> {
    const response: AxiosResponse<PaginatedResponse<Customer>> = await this.http.get('/customers/paginated', { params });
    return response.data;
  }

  async getCustomer(id: string): Promise<Customer> {
    const response: AxiosResponse<Customer> = await this.http.get(`/customers/${id}`);
    return response.data;
  }

  async createCustomer(customer: CreateCustomerRequest): Promise<Customer> {
    const response: AxiosResponse<Customer> = await this.http.post('/customers', customer);
    return response.data;
  }

  async updateCustomer(id: string, customer: UpdateCustomerRequest): Promise<Customer> {
    const response: AxiosResponse<Customer> = await this.http.put(`/customers/${id}`, customer);
    return response.data;
  }

  async deleteCustomer(id: string): Promise<void> {
    await this.http.delete(`/customers/${id}`);
  }

  async searchCustomers(params: SearchParams): Promise<Customer[]> {
    const response: AxiosResponse<Customer[]> = await this.http.get('/customers/search', { params });
    return response.data;
  }

  async bulkUploadCustomers(file: File, companyId?: string): Promise<BulkCustomerUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    if (companyId) formData.append('companyId', companyId);
    const response: AxiosResponse<BulkCustomerUploadResponse> = await this.http.post('/customers/bulk-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }
}
